import { Grid, Typography } from '@material-ui/core';
import { StandardDialog, Button } from '@roc/ui';
import { AIDocReview } from './DocsReview';
import { AIDocType, DocumentName, WithDocumentActions } from '@roc/feature-documents';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

const getTasksWithoutRevisionDocument = (): string[] => [
  DocumentName.CLOSING_REVIEW,
];

const getDialogTitle = (type: AIDocType): string => {
  switch (type) {
    case AIDocType.POST_CLOSING_REVIEW:
      return DocumentName.POST_CLOSING_REVIEW;
    default:
      return `${type} Review`;
  }
};

type DocReviewDialogProps = {
  open?: boolean;
  onClose?: () => void;
  type: AIDocType,
  loanId: any,
  loanTask: Document
};

export const DocReviewDialog = observer((
  props: DocReviewDialogProps
) => {
  const { open, onClose, type, loanId, loanTask } = props;
  const taskId = loanTask?.taskId;

  const { docReviewStore } = useRocInternalPortalStore();
  const { globalStore } = docReviewStore;

  const getTitle = () => {
    return (
      <Grid container spacing={2}>
        <Grid item>
          <Typography variant="h4">{getDialogTitle(type)}</Typography>
        </Grid>
      </Grid>
    );
  };

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={() => {
              onClose();
              docReviewStore.clearStore();
            }}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Close
          </Button>
        </Grid>
        {!globalStore.userFeatures.isClosingAttorney &&
          !docReviewStore.readOnlyForm && (
            <>
              {!getTasksWithoutRevisionDocument().includes(loanTask?.taskName) && (
                <Grid item>
                  <WithDocumentActions
                    document={loanTask}
                    component={Button}
                    onClick={async () => {
                      await docReviewStore.sendRevisionDoc(loanId, type);
                      globalStore.notificationStore.showSuccessNotification({
                        message: 'Revision document sent',
                      });
                      onClose();
                      docReviewStore.clearStore();
                    }}
                    color="primary"
                    variant="contained"
                    testId="save"
                  >
                    Send Revision Document
                  </WithDocumentActions>
                </Grid>
              )}
              <Grid item>
                <WithDocumentActions
                  document={loanTask}
                  component={Button}
                  onClick={async () => {
                    await docReviewStore.saveDocReviewData(loanId, type);
                    globalStore.notificationStore.showSuccessNotification({
                      message: 'Review data saved',
                    });
                    onClose();
                    docReviewStore.clearStore();
                  }}
                  color="primary"
                  variant="contained"
                  testId="save"
                >
                  Save
                </WithDocumentActions>
              </Grid>
            </>
          )}
      </Grid>
    );
  };
  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title={getDialogTitle(type)}
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AIDocReview
                  type={type}
                  loanId={loanId}
                  docReviewStore={docReviewStore}
                  loanTask={loanTask}
                />
              </Grid>
            </Grid>
          }
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title={getTitle()}
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={
            <AIDocReview
              type={type}
              loanId={loanId}
              docReviewStore={docReviewStore}
              loanTask={loanTask}
            />
          }
          dialogActions={getActions()}
        />
      )}
    </>
  );
});

export default DocReviewDialog;
